export default [
  {
    path: '/activity-20260624-main',
    component: () => import('./Page.vue'),
    meta: { title: '夏季联赛', id: 34 },
  },
  {
    path: '/activity-20260624-rule',
    component: () => import('./rule.vue'),
    meta: { title: '夏季联赛-规则说明', id: 34 },
  },
]
